export const siteSettings = {
  name: "Equithub",
  link: "https://equithubpro.live",
  email: "support@equithubpro.live",
  appLink: "https://app.equithubpro.live",
};
